import 'babel-polyfill'
// 引入element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
/** 富文本编辑器 */
import VueUeditorWrap from 'vue-ueditor-wrap'
/** 全局引用富文本 */
Vue.component('vue-ueditor-wrap', VueUeditorWrap)
Vue.use(ElementUI)

/* 路由发生变化修改页面title */
// router.beforeEach((to, from, next) => {
//     if (to.meta.title) {
//         document.title = to.meta.title
//     }
//     next()
// })

    // 引用API文件
import api from './api/index.js'

import './common/scss/element-variables.scss'
import "./assets/icon/iconfont.css"
import "../static/css/base.css"
import "../static/js/flexible.js"
import "../static/css/flexible.css"
//弹窗拖拽
import './common/directives.js';
import util from './utils/util.js'
// 将API方法绑定到全局
Vue.prototype.$api = api
Vue.prototype.$util = util;
Vue.config.productionTip = false
Vue.prototype.$http = axios;
new Vue({
    el: '#app',
    router,
    render: h => h(App),
    components: {
        App
    }
})


// WEBPACK FOOTER //
// ./src/main.js